import getSelectedItemsCount from './getSelectedItemsCount';
import { format } from 'owa-strings';
import { getOwaMiniStrings } from 'owa-strings/owa-mini-strings';

/**
 * Returns the Header title appended with selected items count
 * @param headerText Title of the header.
 */
export default function getHeaderTextWithSelectedItemsCount(headerText: string): string {
    const selectedItemsCount = getSelectedItemsCount();
    const strings = getOwaMiniStrings();
    return selectedItemsCount > 0
        ? format(strings.folderNameInSelectionMode, headerText, selectedItemsCount)
        : headerText;
}
